import { Link } from "react-router-dom";
import { usePageMeta } from "../../../hooks/usePageMeta";
import { quotePath, SITE_TITLE_SUFFIX } from "../../../content/site";

export const NOT_FOUND_TITLE = `Page not found${SITE_TITLE_SUFFIX}`;
export const NOT_FOUND_DESCRIPTION =
  "We’ve rebuilt our website. The page you’re after may have a new address.";

/**
 * Not found (Story #25447, prototype § spec-not-found). The "*" route: any path no screen claims,
 * and any screen that renders notFoundElement() (e.g. an unknown product slug).
 *
 * BR-WEB-091 — links to Home, Products, Contact and Get a quote. Legacy URLs never reach this screen
 * in a deployed portal: server.js answers them with a 301 first (BR-WEB-090).
 *
 * It sets its own title as well as the route-level one, because a screen that renders it in place
 * (an unknown product slug) does not go through the "*" registry entry.
 */
export default function NotFoundPage() {
  usePageMeta(NOT_FOUND_TITLE, NOT_FOUND_DESCRIPTION);

  return (
    <div className="gw-wrap gw-404" data-testid="not-found">
      <div className="code" aria-hidden="true">
        404
      </div>
      <h1 style={{ fontSize: 44, marginTop: 8 }}>This page has moved — or doesn’t exist.</h1>
      <p style={{ fontSize: 18, color: "var(--ink-2)", maxWidth: 560, margin: "16px auto 32px" }}>
        We’ve rebuilt our website. The page you’re after may have a new address.
      </p>
      <nav aria-label="Find your way" className="gw-actions" style={{ justifyContent: "center" }}>
        <Link className="gw-btn gw-btn-red" to="/">
          Home
        </Link>
        <Link className="gw-btn gw-btn-line" to="/products">
          Products
        </Link>
        <Link className="gw-btn gw-btn-line" to="/contact">
          Contact
        </Link>
        <Link className="gw-btn gw-btn-line" to={quotePath()}>
          Get a quote
        </Link>
      </nav>
    </div>
  );
}
